/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {useEffect, useState} from 'react'
import {Link} from 'react-router-dom'
import {getLogoUrl} from '../../../../app/constructor/helpers/dynamicStyles'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import { useThemeMode } from '../../../partials'
import {useLayout} from '../../core'
import {Navbar} from './Navbar'
import {useAuth} from '../../../../app/modules/auth'
import {getApiUrl} from '../../../../app/api'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const {mode} = useThemeMode()
  const {currentUser} = useAuth() as any
  const [logoError, setLogoError] = useState(false)

  const [apiBaseUrl, setApiBaseUrl] = useState(window.location.origin)
  useEffect(() => {
      getApiUrl().then(url => {
          setApiBaseUrl(url)
      })
  }, [])

  const logoSrc = currentUser?.company_logo_url
      ? currentUser.company_logo_url.startsWith('http')
          ? currentUser.company_logo_url
          : `${apiBaseUrl}${currentUser.company_logo_url}`
      : getLogoUrl()

  if (!config.app?.header?.display) {
    return null
  }

  return (
    <div id='kt_app_header' className='app-header'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTSVG path='/media/icons/duotune/abstract/abs015.svg' className=' svg-icon-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <Link to='/dashboard' className='d-lg-none'>
                    {!logoError ? (
                        <img
                            alt='Logo'
                            src={logoSrc}
                            className='h-25px'
                            onError={() => setLogoError(true)}
                        />

                    ) : (
                        <span className='fw-bold fs-4 crm-logo-text'>
                            CRM
                        </span>
                    )}
                </Link>
              </div>
            </div>
          </>
        )}

        {!config.app.sidebar?.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0 me-lg-15'>
            <Link to='/dashboard'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                  className='h-20px h-lg-30px app-sidebar-logo-default'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </Link>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-end flex-lg-grow-1'
        >
          {/* лишнее меню. Можно оставить настройку цвета шапки и меню */}
         {/*  {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='true'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )} */}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
